import React, { useState, useEffect } from "react";
import { useRouter } from "../../util/router";
import PageLoader from "../../components/PageLoader";
import { useV4ReportsData } from "../../util/hooks/useV4ReportsData";
import { handleGetFormId } from "./helper";
import queryString from "query-string";
import "./styles.css";

import Section1 from "../../components/ReportsV4Components/Section1";
import Section3 from "../../components/ReportsV4Components/Section3";
import Section4 from "../../components/ReportsV4Components/Section4";
import Section5 from "../../components/ReportsV4Components/Section5";
import Section6 from "../../components/ReportsV4Components/Section6";
import Section2 from "../../components/ReportsV4Components/Section2";

const RoofingReport = ({ location: { search } }) => {
  const router = useRouter();

  const {
    match: {
      params: { reportId },
    },
  } = router;

  const [loading, setLoading] = useState(true);
  const [formData, setFormata] = useState(null);
  const [reportType, setReportType] = useState(null);
  const reportsData = useV4ReportsData(reportId);

  useEffect(() => {
    const parsedQueryString = queryString.parse(search);
    const { reportDoc } = parsedQueryString;
    setReportType(reportDoc);
  }, [search]);

  useEffect(() => {
    reportsData && setLoading(false);
    reportsData &&
      handleGetFormId(
        setFormata,
        "team@remoteroofing.com",

        Number(reportType) === 2
          ? reportsData?.data?.document2id
          : reportsData?.data?.documentId
      );
  }, [reportsData]);

  return (
    <div>
      {loading ? (
        <PageLoader />
      ) : (
        <div id="main">
          <Section1
            address={reportsData?.data?.address}
            homeFrontView={reportsData?.data?.cover_image[0].url}
          />
          <Section2
            damageMetricsImage={reportsData?.data?.damage_metrics[0].url}
            hailImpacts={reportsData?.data?.hail_impacts}
            anomalies={reportsData?.data?.anomalies}
            windDamages={reportsData?.data?.wind_damages}
            hailStorms={reportsData?.data?.hail_storms}
            moistureExposure={reportsData?.data?.moisture_exposure[0].url}
          />
          <Section3 />
          <Section4 formData={formData} />
          <Section5 />
          <Section6 />
        </div>
      )}
    </div>
  );
};

export default RoofingReport;
